// @ts-nocheck
import React from 'react'
import styles from './BarChart.module.scss'
import cx from 'classnames'

export const BarChart = ({
  data,
  selected,
  setSelected,
  candidates,
  selectedCandidates,
}) => {
  return (
    <div className={styles.chart}>
      {[0, 1, 2, 3, 4].map(step => (
        <div key={step} className={styles.step}>
          <div className={styles.indicator}>{step}</div>
        </div>
      ))}

      {data.map((section, index) => {
        const { score, score2, label } = section

        return (
          <div
            className={cx(
              styles.section,
              index ? styles.sectionRight : styles.sectionLeft,
            )}
            key={label}
          >
            <div className={styles.bars}>
              {selectedCandidates[candidates[0].id] ? (
                <div
                  className={cx(styles.bar, styles.first)}
                  style={{ [`--height`]: `${score * 50}px` }}
                ></div>
              ) : null}

              {selectedCandidates[candidates[1].id] ? (
                <div
                  className={cx(styles.bar, styles.second)}
                  style={{ [`--height`]: `${score2 * 50}px` }}
                ></div>
              ) : null}
            </div>

            <div
              className={cx(styles.label, {
                [styles.selected]: index === selected,
              })}
              onClick={() => setSelected(index)}
            >
              {label}
            </div>
          </div>
        )
      })}
    </div>
  )
}
